module.exports = __webpack_public_path__ + "static/img/centros-educativos.520fd102.png";